import React from 'react';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import GUID from 'bz-utilities/modules/variables/guid';
import { Colors } from 'bz-core-controls/styles/colours';
import featureFlag from 'tm3-core/stores/feature-store';
import './style.styl';

@observer
class PayControl extends React.Component {
  render() {
    if (!this.show) {
      return <div>{this.props.children}</div>;
    }

    let style = {
      padding: 4,
      background: '#f1f8e9',
      borderLeft: '5px solid #558b2f'
    };

    let iconStyle = {
      color: Colors.blue500,
      borderColor: Colors.blue500
    };

    return (
      <div>
        <div style={style}>
          <div className="flex-row" style={{ alignItems: 'center' }}>
            <div className="flex-none" style={{ flexBasis: '74px', justifyContent: 'center' }}>
              <div className="statusLabel" style={iconStyle}>
                PRONTO
              </div>
            </div>
            <div className="flex-both">
              Charges and Invoices created here will be billed automatically via Pronto
            </div>
          </div>
        </div>
        {this.props.children}
      </div>
    );
  }

  @computed
  get show() {
    const { appointment = {}, isMyClinicIntegration } = this.props;
    const { auditId, prontoServiceId } = appointment;

    if (!!isMyClinicIntegration) {
      return featureFlag.prontoIntegrationEnabled && !!isMyClinicIntegration;
    }
    return (
      GUID.hasValue(auditId) &&
      GUID.hasValue(prontoServiceId) &&
      featureFlag.prontoIntegrationEnabled
    );
  }
}

export default PayControl;
